import {post} from "../utils/http.ts";
import {BASE_URL} from "./index.ts";
import {Optional} from "../utils/types.ts";

type UserTokenResponse = {
  token: string,
  expires_at: Optional<string>
}

type ForgotPasswordResponse = {
  message: string,
  error?: string
}

export async function getUserToken(formData: FormData): Promise<UserTokenResponse> {
  return post<UserTokenResponse>(new URL(`${BASE_URL}/auth/token`), { formData });
}

export async function signUp(formData: FormData): Promise<UserTokenResponse> {
  const body = {
    email: formData.get('email'),
    password: formData.get('password'),
    first_name: formData.get('first_name') || undefined,
    last_name: formData.get('last_name') || undefined
  }
  return post<UserTokenResponse>(new URL(`${BASE_URL}/auth/sign_up`), { body, headers: { 'Content-Type': 'application/json' } });
}

export async function forgotPassword(formData: FormData): Promise<ForgotPasswordResponse> {
  const body = {
    email: formData.get('email')
  }
  return post<ForgotPasswordResponse>(new URL(`${BASE_URL}/auth/request_password_reset`), { body, headers: { 'Content-Type': 'application/json' } });
}

export async function resetPassword(formData: FormData): Promise<UserTokenResponse> {
  const body = {
    token: formData.get('token'),
    password: formData.get('password')
  }
  return post<UserTokenResponse>(new URL(`${BASE_URL}/auth/reset_password`), { body, headers: { 'Content-Type': 'application/json' } });
}